const HOST = window.location.host

const apiObj = {
  VUE_APP_NAME: HOST === 'c.banhuiyun.com' ? 'production' : 'development',
  VUE_APP_BASE_API:
    HOST === 'c.banhuiyun.com'
      ? 'https://api.banhuiyun.com'
      : 'http://api.bhykf.com',
  VUE_APP_UPYUN_API:
    HOST === 'c.banhuiyun.com'
      ? 'https://v0.api.upyun.com'
      : 'http://v0.api.upyun.com',
  VUE_APP_BASE_SERVE:
    HOST === 'c.banhuiyun.com'
      ? 'https://c.banhuiyun.com/'
      : 'http://c.bhykf.com/',
  VUE_APP_BASE_ASSETS:
    HOST === 'c.banhuiyun.com'
      ? 'https://assets.banhuiyun.com'
      : 'http://assets.bhykf.com',
  VUE_APP_BASE_CDN:
    HOST === 'c.banhuiyun.com'
      ? 'https://cdn.banhuiyun.com'
      : 'https://cdn.bhykf.com',
}

module.exports = apiObj
